import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { lowerCase, startCase } from "lodash";
import { LoadingService } from "../../../core/loader/loading.service";
import { UserTypes } from "../../types/user-info";
import { NotificationService } from "../notification/notification.service";
import { DeleteWarningMessages as warningMessages } from "./delete-modal-messages";

@Component({
  selector: "app-delete-modal",
  templateUrl: "./delete-modal.component.html",
  styleUrls: ["./delete-modal.component.css"],
})
export class DeleteModalComponent implements OnInit {
  currentValue = "";
  loading$ = this.loader.loading$;
  operation = "delete";
  pastOperation = "deleted";
  nowOperation = "deleting";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    private http: HttpClient,
    private loader: LoadingService,
    private notificationService: NotificationService,
  ) {}

  get warningMsg(): string {
    return warningMessages[this.data.warningEntity ?? this.data.name];
  }

  get warningMsg2(): string {
    return this.data.warningMessage;
  }

  @HostListener("window:keyup.esc") onKeyUp(): void {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {
    this.operation = this.data.unlink ? "unlink" : this.operation;
  }

  delete(): void {
    this.loader.show();
    const url = this.data.overwrittenUrl ?? `${this.data.url}/${this.data.data.id}`;
    const options = this.data.body
      ? {
          headers: new HttpHeaders({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "Content-Type": "application/json",
          }),
          body: this.data.body,
        }
      : {};
    this.http
      .delete(url, options)
      .subscribe(
        () => {
          this.dialogRef.close(true);
          this.notificationService.success(`${startCase(this.data.name)} has been deleted`);
        },
        (err) => {
          /** @workaround for deleting a company having tickets (with comments) or linked to sales reps */
          if (this.data.name === UserTypes.Company && (err as string)?.includes("CONSTRAINT")) {
            err = "Company cannot be deleted due to having Tickets/Linked Sales Representatives";
          }
          const error = `There was an error deleting this ${lowerCase(this.data.name)}:\n ${err}`;
          this.notificationService.error(error);
        },
      )
      .add(() => this.loader.hide());
  }

  unlink(): void {
    this.loader.show();
    const options = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
      }),
      body: this.data.body,
    };
    this.http
      .delete(this.data.fullUrl, options)
      .subscribe(
        () => {
          this.dialogRef.close(true);
          this.notificationService.success(`${startCase(this.data.name)} has been unlinked`);
        },
        (err) => {
          const error = `There was an error unlinking this ${lowerCase(this.data.name)}:\n ${err}`;
          this.notificationService.error(error);
        },
      )
      .add(() => this.loader.hide());
  }

  clearField(): void {
    this.currentValue = "";
  }
}
